import { Reveal } from "./Reveal";

// En-tête de page intérieure (éditorial, chapitre numéroté)
export const PageHero = ({ chapter, title, subtitle, children }) => (
  <section className="relative max-w-[1400px] mx-auto px-6 md:px-12 pt-10 md:pt-16 pb-6">
    <Reveal>
      {chapter && (
        <span className="text-xs uppercase tracking-[0.4em] text-olive font-semibold">{chapter}</span>
      )}
      <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl text-forest tracking-tight max-w-4xl leading-[1.02]">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-6 text-lg text-ink-soft max-w-2xl leading-relaxed">{subtitle}</p>
      )}
      {children}
    </Reveal>
  </section>
);
